import { render, staticRenderFns } from "./Processes.vue?vue&type=template&id=4edbd54c"
import script from "./Processes.vue?vue&type=script&lang=ts"
export * from "./Processes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports